import React from "react"

import { NO, YES } from "const"
import { LangType } from "client/store"
import { TableColumnEditable } from "client/components"

import { MtPackage } from "server/models"

import TableSelect from "../components/select"

const Qid = (lang: LangType) => {
    const columns: TableColumnEditable[] = [
        {
            field: "qidMasterAccess",
            header: lang.qidMasterAccess,
            formatter: (packg: MtPackage) => {
                const { qidModuleAccess } = packg.settingsParsed
                return lang[qidModuleAccess]
            },
            focusedFormatter: (packg: MtPackage) => {
                const { qidModuleAccess } = packg.settingsParsed
                return (
                    <TableSelect
                        text={lang[qidModuleAccess]}
                        label={lang.qidMasterAccess}
                        property={{ qidModuleAccess }}
                        propertyArray={[NO, YES]}
                    />
                )
            },
        },
    ]

    return columns
}
export default Qid
